import React from 'react';

import styles from './css/NewUserSignup.module.css';


function CheckEmailMessage() {
  return (
    <div className={styles.signupMessage}>
      <div className={styles.newUserSignup}>
        <h1 className={styles.textBlue}>
          Check Your Email to Activate!
        </h1>
        <p className={styles.paragraph}>
          You will receive an email from us at info@apps.nakednews.com. Please click the 'Activate Your Account' button in your email to activate your <b>free access account.</b>
        </p>
      </div>
    </div>
  );
}

export default CheckEmailMessage;
